import React from 'react';
import { SelectedStand } from '../types/stand.types';

interface SelectedStandsProps {
  selectedStands: SelectedStand[];
  onRemoveStand: (standId: string) => void;
}

const SelectedStands: React.FC<SelectedStandsProps> = ({ selectedStands, onRemoveStand }) => {
  return (
    <div className="selected-stands">
      <h3 className="selected-stands-title">Stands Seleccionados</h3>
      {selectedStands.length === 0 ? (
        <div className="empty-selection">
          <p>Haz clic en los stands para seleccionarlos</p>
        </div>
      ) : (
        <div className="stands-list">
          {selectedStands.map(stand => (
            <div key={stand.id} className="selected-stand">
              <div className="selected-stand-info">
                <span className="selected-stand-number">{stand.name}</span>
                {stand.size && <span className="selected-stand-size">{stand.size}</span>}
              </div>
              <button 
                className="remove-stand"
                onClick={() => onRemoveStand(stand.id)}
              >
                ✕
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SelectedStands;
